@if(!isConfirmSuccessfullFlag){

  <div id="mail-confirm"  class="inner-scroll login-main">
  </div>
  }
  
  
  @if(!isAlreadyConfirmFlag && !isReactivaionEmalSendFlag){
  <div id="mail-confirm"  class="inner-scroll login-main" fxLayout="column">
    <div class="absolute inset-0 top-0 left-0">
      <img src="../images/new/dark-material-bg.jpg" class="h-full object-cover"/>
  </div>
    @if(isConfirmSuccessfull && isConfirmSuccessfullFlag && !isAlreadyConfirmFlag){
    <div id="mail-confirm-form-wrapper" class="login-wrapper bg-white" fxLayout="column" fxLayoutAlign="center center">
      <div id="mail-confirm-form" class="p-relative w-full shadow-none" [@animate]="{value:'*',params:{duration:'300ms',y:'100px'}}">
         <!-- Logo -->
         <div class="w-40 m-auto">
          <img src="../images/new/biz-logo.png" alt="Logo">
        </div>
  
        <!-- Title -->
        <div class="mt-5 auth-title text-2xl">
          Email Confirm Successfully
        </div>
        <div class="mt-0.5 font-medium text-center">
          Email confirmed successfully. We'll Contact you soon after verifying your profile.
          
        </div>
        <div class="mt-8">
          <div class="text-secondary text-center mt-4 text-md font-medium">
              <span>Return to</span>
              <a
                  class="ml-1 text-primary-500 hover:underline"
                  [routerLink]="['/sign-in']"
                  >Sign In
              </a>
          </div>
  </div>
      </div>
    </div>
    }
    @if(!isConfirmSuccessfull && isConfirmSuccessfullFlag){
    <div id="mail-confirm-form-wrapper" class="login-wrapper bg-white" fxLayout="column" fxLayoutAlign="center center">
      <div id="mail-confirm-form" class="p-relative w-full shadow-none" [@animate]="{value:'*',params:{duration:'300ms',y:'100px'}}">
         <!-- Logo -->
         <div class="w-40 m-auto">
          <img src="../images/new/biz-logo.png" alt="Logo">
         </div>
  
          <!-- Title -->
          <div class="mt-5 auth-title text-2xl">
            Link Expired
          </div>
        <div class="mt-0.5 font-medium text-center">
          Link you tried to access is expired. <a class="text-primary-500 hover:underline" (click)="reActivation()">Click here to get new activation email</a>
          
        </div>
        <div class="mt-8">
          <div class="text-secondary text-center mt-4 text-md font-medium">
              <span>Return to</span>
              <a
                  class="ml-1 text-primary-500 hover:underline"
                  [routerLink]="['/sign-in']"
                  >Sign In
              </a>
          </div>
  </div>
      </div>
    </div>
    }
  </div>
  }
  @if(isAlreadyConfirmFlag && !isReactivaionEmalSendFlag){
  <div id="mail-confirm"  class="inner-scroll login-main" fxLayout="column">
    <div class="absolute inset-0 top-0 left-0">
      <img src="../images/new/dark-material-bg.jpg" class="h-full object-cover"/>
  </div>
  
    <div id="mail-confirm-form-wrapper" class="login-wrapper bg-white" fxLayout="column" fxLayoutAlign="center center">
      <div id="mail-confirm-form" class="p-relative w-full shadow-none" [@animate]="{value:'*',params:{duration:'300ms',y:'100px'}}">
        <!-- Logo -->
        <div class="w-40 m-auto">
          <img src="../images/new/biz-logo.png" alt="Logo">
     </div>
  
        <div class="mt-0.5 font-medium text-center">
          {{message}}
         
        </div>
        <div class="mt-8">
          <div class="text-secondary text-center mt-4 text-md font-medium">
              <span>Return to</span>
              <a
                  class="ml-1 text-primary-500 hover:underline"
                  [routerLink]="['/sign-in']"
                  >Sign In
              </a>
          </div>
  </div>
      </div>
    </div>
  </div>
  }
  @if(isReactivaionEmalSendFlag){
  <div id="mail-confirm"  class="inner-scroll login-main" fxLayout="column">
    <div class="absolute inset-0 top-0 left-0">
      <img src="../images/new/dark-material-bg.jpg" class="h-full object-cover"/>
  </div>
    <div id="mail-confirm-form-wrapper" class="login-wrapper bg-white" fxLayout="column" fxLayoutAlign="center center">
      <div id="mail-confirm-form" class="p-relative w-full shadow-none" [@animate]="{value:'*',params:{duration:'300ms',y:'100px'}}">
         <!-- Logo -->
         <div class="w-40 m-auto">
          <img src="../images/new/biz-logo.png" alt="Logo">
        </div>
  
          <!-- Title -->
          <div class="mt-5 auth-title text-2xl">
              Confirm your email address!
          </div>
        <div class="mt-0.5 font-medium text-center">
          {{message}}
          
        </div>
         <div class="mt-8">
                  <div class="text-secondary text-center mt-4 text-md font-medium">
                      <span>Return to</span>
                      <a
                          class="ml-1 text-primary-500 hover:underline"
                          [routerLink]="['/sign-in']"
                          >Sign In
                      </a>
                  </div>
          </div>
      </div>
    </div>
  </div>
  }